import { Tab, Tabs, Typography } from "@mui/material";
import useColors from "../../../../../../api/hooks/useColors";

export const MisconfigStatusTab = Object.freeze({
  INCLUDED: "included",
  EXCLUDED: "excluded",
  SNOOZED: "snoozed",
});

export default function MisconfigStatusTabs({
  entitiesByTypeAndStatus,
  selectedEntityTypeTab,
  selectedStatusTab,
  setSelectedStatusTab,
}) {
  const colors = useColors();
  return (
    <Tabs
      value={selectedStatusTab}
      onChange={(_, newValue) => {
        setSelectedStatusTab(newValue);
      }}
      sx={{
        "& .MuiTabs-indicator": {
          backgroundColor: colors.primary_main,
        },
        minHeight: "unset",
        "& .MuiTab-root": {
          minHeight: "unset",
          height: "36px",
        },
      }}
    >
      {[
        [MisconfigStatusTab.INCLUDED, "Included"],
        [MisconfigStatusTab.EXCLUDED, "Excluded"],
        [MisconfigStatusTab.SNOOZED, "Snoozed"],
      ].map(([statusTab, label]) => {
        const contentLength =
          entitiesByTypeAndStatus[selectedEntityTypeTab][statusTab]?.length ||
          0;
        return (
          <Tab
            key={statusTab}
            sx={{
              textTransform: "none",
            }}
            label={
              <Typography
                variant={
                  statusTab === selectedStatusTab ? "overline" : "caption"
                }
              >
                {label} ({contentLength})
              </Typography>
            }
            value={statusTab}
            disableRipple
          />
        );
      })}
    </Tabs>
  );
}
